<template>
    <aj-form-detail :dialogTitle="dialogTitle" :dialog-visible.sync="visible" :footer-buttons="finalFooterButtons"
        :sections="detailSections" dialogWidth="1200px" :detailData="detailData" :custom-sections="customSections">
        <template #aiCourseOutlineList>

            <div class="ai-optimize-container"
                style="margin-top: 20px; padding: 20px; background: #f8fafc; border-radius: 8px; border: 1px solid #ebeef5;">
                <!-- 模式2：直接渲染对比数据（不显示输入表单） -->
                <div v-if="AiDiaLogDetailType === 2 && AiDiaLogShow">
                    <!-- AI 优化结果展示区 - 直接显示对比 -->
                    <div class="ai-result-section"
                        style="padding: 20px; background: white; border-radius: 8px; border: 1px solid #ebeef5;">
                        <!-- 1. 课程简介对比 -->
                        <div class="comparison-section" style="margin-bottom: 20px;">
                            <h4 style="margin-bottom: 10px; color: #1e293b; display: flex; align-items: center; gap: 8px;">
                                <i class="el-icon-info" style="color: #409EFF;"></i>
                                1. 课程简介对比
                            </h4>
                            <div style="display: flex; gap: 20px;">
                                <!-- 原版数据 -->
                                <div
                                    style="flex: 1; border: 1px solid #e2e8f0; border-radius: 8px; padding: 15px; background: #f8fafc;">
                                    <div style="font-size: 12px; color: #666; margin-bottom: 8px;">原版数据 (OLD)</div>
                                    <pre
                                        style="font-family: inherit; white-space: pre-wrap; word-break: break-word; line-height: 1.6; padding: 10px; background: #fff; border-radius: 4px; border: 1px solid #ddd; margin: 0; font-size: 13px; color: #333;">
{{ formatTextForDisplay(AiShowDetailData?.courseIntroduce) }}
</pre>
                                </div>
                                <!-- AI优化版本 -->
                                <div
                                    style="flex: 1; border: 1px solid #e2e8f0; border-radius: 8px; padding: 15px; background: #f8fafc;">
                                    <div style="font-size: 12px; color: #409EFF; margin-bottom: 8px;">AI 优化版本</div>
                                    <el-input :key="optimizeKey + '-introduce'" v-model="aiRefineData.courseIntroduce"
                                        type="textarea" rows="8" style="width: 100%;"></el-input>
                                </div>
                            </div>
                        </div>
                        <!-- 2. 教学目标对比 -->
                        <div class="comparison-section" style="margin-bottom: 20px;">
                            <h4 style="margin-bottom: 10px; color: #1e293b; display: flex; align-items: center; gap: 8px;">
                                <i class="el-icon-aim" style="color: #409EFF;"></i>
                                2. 教学目标对比
                            </h4>
                            <div style="display: flex; gap: 20px;">
                                <!-- 原版数据 -->
                                <div
                                    style="flex: 1; border: 1px solid #e2e8f0; border-radius: 8px; padding: 15px; background: #f8fafc;">
                                    <div style="font-size: 12px; color: #666; margin-bottom: 8px;">原版数据 (OLD)</div>
                                    <pre
                                        style="font-family: inherit; white-space: pre-wrap; word-break: break-word; line-height: 1.6; padding: 10px; background: #fff; border-radius: 4px; border: 1px solid #ddd; margin: 0; font-size: 13px; color: #333;">
{{ formatTextForDisplay(AiShowDetailData?.courseTarget) }}
</pre>
                                </div>
                                <!-- AI优化版本 -->
                                <div
                                    style="flex: 1; border: 1px solid #e2e8f0; border-radius: 8px; padding: 15px; background: #f8fafc;">
                                    <div style="font-size: 12px; color: #409EFF; margin-bottom: 8px;">AI 优化版本</div>
                                    <template v-if="Array.isArray(aiRefineData.courseTarget)">
                                        <el-input v-for="(item, index) in aiRefineData.courseTarget"
                                            :key="optimizeKey + '-target-' + index"
                                            v-model="aiRefineData.courseTarget[index]" type="textarea" rows="4"
                                            style="width: 100%; margin-bottom: 12px;"></el-input>
                                    </template>
                                    <el-input v-else :key="optimizeKey + '-target-single'"
                                        v-model="aiRefineData.courseTarget" type="textarea" rows="8"
                                        style="width: 100%;"></el-input>
                                </div>
                            </div>
                        </div>
                        <!-- 3. 特色亮点对比 -->
                        <div class="comparison-section" style="margin-bottom: 20px;">
                            <h4 style="margin-bottom: 10px; color: #1e293b; display: flex; align-items: center; gap: 8px;">
                                <i class="el-icon-star-on" style="color: #409EFF;"></i>
                                3. 特色亮点对比
                            </h4>
                            <div style="display: flex; gap: 20px;">
                                <!-- 原版数据 -->
                                <div
                                    style="flex: 1; border: 1px solid #e2e8f0; border-radius: 8px; padding: 15px; background: #f8fafc;">
                                    <div style="font-size: 12px; color: #666; margin-bottom: 8px;">原版数据 (OLD)</div>
                                    <pre
                                        style="font-family: inherit; white-space: pre-wrap; word-break: break-word; line-height: 1.6; padding: 10px; background: #fff; border-radius: 4px; border: 1px solid #ddd; margin: 0; font-size: 13px; color: #333;">
                {{ formatTextForDisplay(AiShowDetailData?.courseSpecialty) }}
            </pre>
                                </div>
                                <!-- AI优化版本 -->
                                <div
                                    style="flex: 1; border: 1px solid #e2e8f0; border-radius: 8px; padding: 15px; background: #f8fafc;">
                                    <div style="font-size: 12px; color: #409EFF; margin-bottom: 8px;">AI 优化版本</div>
                                    <template v-if="Array.isArray(aiRefineData.courseSpecialty)">
                                        <el-input v-for="(item, index) in aiRefineData.courseSpecialty"
                                            :key="optimizeKey + '-specialty-' + index"
                                            v-model="aiRefineData.courseSpecialty[index]" type="textarea" rows="4"
                                            style="width: 100%; margin-bottom: 12px;"></el-input>
                                    </template>
                                    <el-input v-else :key="optimizeKey + '-specialty-single'"
                                        v-model="aiRefineData.courseSpecialty" type="textarea" rows="8"
                                        style="width: 100%;"></el-input>
                                </div>
                            </div>
                        </div>
                        <!-- 4. 预期成果对比 -->
                        <div class="comparison-section" style="margin-bottom: 20px;">
                            <h4 style="margin-bottom: 10px; color: #1e293b; display: flex; align-items: center; gap: 8px;">
                                <i class="el-icon-success" style="color: #409EFF;"></i>
                                4. 预期成果对比
                            </h4>
                            <div style="display: flex; gap: 20px;">
                                <!-- 原版数据 -->
                                <div
                                    style="flex: 1; border: 1px solid #e2e8f0; border-radius: 8px; padding: 15px; background: #f8fafc;">
                                    <div style="font-size: 12px; color: #666; margin-bottom: 8px;">原版数据 (OLD)</div>
                                    <pre
                                        style="font-family: inherit; white-space: pre-wrap; word-break: break-word; line-height: 1.6; padding: 10px; background: #fff; border-radius: 4px; border: 1px solid #ddd; margin: 0; font-size: 13px; color: #333;">
                {{ formatTextForDisplay(AiShowDetailData?.courseExpectedOutcome) }}
            </pre>
                                </div>
                                <!-- AI优化版本 -->
                                <div
                                    style="flex: 1; border: 1px solid #e2e8f0; border-radius: 8px; padding: 15px; background: #f8fafc;">
                                    <div style="font-size: 12px; color: #409EFF; margin-bottom: 8px;">AI 优化版本</div>
                                    <template v-if="Array.isArray(aiRefineData.courseExpectedOutcome)">
                                        <el-input v-for="(item, index) in aiRefineData.courseExpectedOutcome"
                                            :key="optimizeKey + '-outcome-' + index"
                                            v-model="aiRefineData.courseExpectedOutcome[index]" type="textarea" rows="4"
                                            style="width: 100%; margin-bottom: 12px;"></el-input>
                                    </template>
                                    <el-input v-else :key="optimizeKey + '-outcome-single'"
                                        v-model="aiRefineData.courseExpectedOutcome" type="textarea" rows="8"
                                        style="width: 100%;"></el-input>
                                </div>
                            </div>
                        </div>
                        <!-- 5. 课程大纲对比 -->
                        <div class="comparison-section" style="margin-bottom: 20px;">
                            <h4 style="margin-bottom: 10px; color: #1e293b; display: flex; align-items: center; gap: 8px;">
                                <i class="el-icon-document-copy" style="color: #409EFF;"></i>
                                5. 课程大纲对比
                            </h4>
                            <div style="display: flex; gap: 20px;">
                                <!-- 原版数据 -->
                                <div
                                    style="flex: 1; border: 1px solid #e2e8f0; border-radius: 8px; padding: 15px; background: #f8fafc; overflow-y: auto; max-height: 400px;">
                                    <div style="font-size: 12px; color: #666; margin-bottom: 8px;">原版数据 (OLD)</div>
                                    <div
                                        style="font-family: inherit; white-space: pre-wrap; word-break: break-word; line-height: 1.6; padding: 10px; background: #fff; border-radius: 4px; border: 1px solid #ddd; font-size: 13px; color: #333;">
                                        {{ formatTextForDisplay(AiShowDetailData?.courseOutline) }}
                                    </div>
                                </div>
                                <!-- AI优化版本 -->
                                <div
                                    style="flex: 1; border: 1px solid #e2e8f0; border-radius: 8px; padding: 15px; background: #f8fafc; overflow-y: auto; max-height: 500px;">
                                    <div style="font-size: 12px; color: #409EFF; margin-bottom: 8px;">AI 优化版本</div>
                                    <div
                                        v-if="Array.isArray(aiRefineData.courseOutline) && aiRefineData.courseOutline.length > 0">
                                        <div v-for="(module, modIndex) in aiRefineData.courseOutline"
                                            :key="optimizeKey + '-mod-' + modIndex" :style="{
                                                marginBottom: '20px',
                                                paddingLeft: '8px',
                                                borderLeft: module.hasModified ? '3px solid #67C23A' : '3px solid #409EFF',
                                                background: module.hasModified ? 'rgba(103, 194, 58, 0.05)' : 'transparent',
                                                padding: '10px',
                                                borderRadius: '4px'
                                            }">
                                            <!-- 一级标题 -->
                                            <div style="position: relative;">
                                                <el-tag v-if="module.hasModified" type="success" size="mini"
                                                    style="position: absolute; right: 0; top: -5px; z-index: 10;">修改</el-tag>
                                                <el-input :key="optimizeKey + '-mod-title-' + modIndex"
                                                    v-model="module.title" type="textarea" rows="2" :style="{
                                                        width: '100%',
                                                        fontWeight: 'bold',
                                                        marginBottom: '12px'
                                                    }"></el-input>
                                            </div>
                                            <!-- 二级标题 -->
                                            <div v-for="(section, secIndex) in module.subSections"
                                                :key="optimizeKey + '-sec-' + modIndex + '-' + secIndex" :style="{
                                                    marginLeft: '20px',
                                                    marginBottom: '16px',
                                                    paddingLeft: '8px',
                                                    borderLeft: section.hasModified ? '2px solid #E6A23C' : '2px solid #909399',
                                                    background: section.hasModified ? 'rgba(230, 162, 60, 0.05)' : 'transparent',
                                                    padding: '8px',
                                                    borderRadius: '4px'
                                                }">
                                                <div style="position: relative;">
                                                    <el-tag v-if="section.hasModified" type="warning" size="mini"
                                                        style="position: absolute; right: 0; top: -5px; z-index: 10;">修改</el-tag>
                                                    <el-input :key="optimizeKey + '-sec-title-' + modIndex + '-' + secIndex"
                                                        v-model="section.title" type="textarea" rows="2" :style="{
                                                            width: '100%',
                                                            fontWeight: '500',
                                                            marginBottom: '8px'
                                                        }"></el-input>
                                                </div>
                                                <!-- 三级标题 -->
                                                <div v-for="(subSection, subSecIndex) in section.subSubSections"
                                                    :key="optimizeKey + '-sub-' + modIndex + '-' + secIndex + '-' + subSecIndex"
                                                    :style="{
                                                        marginLeft: '20px',
                                                        marginBottom: '8px',
                                                        padding: '6px',
                                                        borderRadius: '4px',
                                                        background: getSubSectionStyle(subSection.title).background,
                                                        borderLeft: getSubSectionStyle(subSection.title).borderLeft
                                                    }">
                                                    <div style="position: relative;">
                                                        <el-tag v-if="getSubSectionStyle(subSection.title).isNew"
                                                            type="success" size="mini"
                                                            style="position: absolute; right: 0; top: -5px; z-index: 10;">新增</el-tag>
                                                        <el-tag v-else-if="getSubSectionStyle(subSection.title).isModified"
                                                            type="warning" size="mini"
                                                            style="position: absolute; right: 0; top: -5px; z-index: 10;">优化</el-tag>
                                                        <el-input
                                                            :key="optimizeKey + '-sub-title-' + modIndex + '-' + secIndex + '-' + subSecIndex"
                                                            v-model="subSection.title" type="textarea" rows="2" :style="{
                                                                width: '100%',
                                                                fontSize: '13px',
                                                                color: '#555'
                                                            }"></el-input>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <el-input v-else :key="optimizeKey + '-outline-single'"
                                        v-model="aiRefineData.courseOutline" type="textarea" rows="10"
                                        style="width: 100%;"></el-input>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 模式1：AI优化输入表单（当AiDiaLogShow为false或者AiDiaLogDetailType为1时显示） -->
                <div v-if="!AiDiaLogShow || AiDiaLogDetailType === 1">
                    <div class="ai-optimize-header"
                        style="display: flex; align-items: center; gap: 8px; margin-bottom: 15px;">
                        <i class="el-icon-lightbulb" style="color: #409EFF; font-size: 18px;"></i>
                        <h3 style="font-size: 16px; font-weight: bold; color: #333; margin: 0;">AI 深度优化需求分析</h3>
                    </div>
                    <div class="ai-optimize-form"
                        style="display: flex; gap: 20px; flex-wrap: wrap; align-items: stretch;">
                        <!-- 需求描述 -->
                        <div style="flex: 1; min-width: 250px; max-width: 400px;">
                            <label
                                style="display: block; font-size: 13px; color: #666; margin-bottom: 5px;">需求描述</label>
                            <el-input v-model="aiOptimizeForm.requirementDesc" placeholder="扩展" type="textarea" rows="3"
                                style="width: 100%;"></el-input>
                        </div>
                        <!-- 面向人群 -->
                        <div style="flex: 1; min-width: 250px; max-width: 400px;">
                            <label
                                style="display: block; font-size: 13px; color: #666; margin-bottom: 5px;">面向人群</label>
                            <el-input v-model="aiOptimizeForm.targetAudience" placeholder="请描述培训对象，例如：企业中高层管理者、技术骨干..."
                                type="textarea" rows="3" style="width: 100%;"></el-input>
                        </div>
                        <!-- 针对客户 -->
                        <div style="flex: 1; min-width: 250px; max-width: 400px;">
                            <label
                                style="display: block; font-size: 13px; color: #666; margin-bottom: 5px;">针对客户（企业文化审核）</label>
                            <el-input v-model="aiOptimizeForm.targetCustomer"
                                placeholder="请输入客户企业名称，AI将审核课纲是否符合该企业文化..." type="textarea" rows="3"
                                style="width: 100%;"></el-input>
                        </div>
                        <!-- 时长 -->
                        <div style="flex: 1; min-width: 250px; max-width: 400px;">
                            <label
                                style="display: block; font-size: 13px; color: #666; margin-bottom: 5px;">课程时长</label>
                            <el-input v-model="aiOptimizeForm.courseDays" placeholder="请输入课程时长"
                                style="width: 100%;margin-top: 10px;"></el-input>
                        </div>
                    </div>
                    <!-- 按钮区域 -->
                    <div class="ai-optimize-actions"
                        style="display: flex; justify-content: flex-end; gap: 10px; margin-top: 20px;">
                        <el-button class="ai-btn" type="primary" size="medium"
                            style="background: linear-gradient(135deg, #409EFF 0%, #2D7BEF 100%); color: white; border: none;"
                            @click="handleAiOptimizeClick">
                            <i class="el-icon-magic-stick" style="margin-right: 5px;"></i>
                            AI 深度优化
                        </el-button>
                    </div>
                </div>

                <!-- AI 优化结果展示区 -->
                <div v-if="isOptimized" class="ai-result-section"
                    style="margin-top: 20px; padding: 20px; background: white; border-radius: 8px; border: 1px solid #ebeef5;">
                    <!-- 1. 课程简介对比 -->
                    <div class="comparison-section" style="margin-bottom: 20px;">
                        <h4 style="margin-bottom: 10px; color: #1e293b; display: flex; align-items: center; gap: 8px;">
                            <i class="el-icon-info" style="color: #409EFF;"></i>
                            1. 课程简介对比
                        </h4>
                        <div style="display: flex; gap: 20px;">
                            <!-- 原始版本 -->
                            <div
                                style="flex: 1; border: 1px solid #e2e8f0; border-radius: 8px; padding: 15px; background: #f8fafc;">
                                <div style="font-size: 12px; color: #666; margin-bottom: 8px;">原始版本 (OLD)</div>
                                <pre
                                    style="font-family: inherit; white-space: pre-wrap; word-break: break-word; line-height: 1.6; padding: 10px; background: #fff; border-radius: 4px; border: 1px solid #ddd; margin: 0; font-size: 13px; color: #333;">
{{ formatTextForDisplay(currentVersionData?.courseIntroduce) }}
</pre>
                            </div>
                            <!-- AI优化版本 -->
                            <div
                                style="flex: 1; border: 1px solid #e2e8f0; border-radius: 8px; padding: 15px; background: #f8fafc;">
                                <div style="font-size: 12px; color: #409EFF; margin-bottom: 8px;">AI 优化版本 (可编辑)</div>
                                <el-input :key="optimizeKey + '-introduce'" v-model="aiRefineData.courseIntroduce"
                                    type="textarea" rows="8" style="width: 100%;"></el-input>
                            </div>
                        </div>
                    </div>
                    <!-- 2. 教学目标对比 -->
                    <div class="comparison-section" style="margin-bottom: 20px;">
                        <h4 style="margin-bottom: 10px; color: #1e293b; display: flex; align-items: center; gap: 8px;">
                            <i class="el-icon-aim" style="color: #409EFF;"></i>
                            2. 教学目标对比
                        </h4>
                        <div style="display: flex; gap: 20px;">
                            <!-- 原始版本 -->
                            <div
                                style="flex: 1; border: 1px solid #e2e8f0; border-radius: 8px; padding: 15px; background: #f8fafc;">
                                <div style="font-size: 12px; color: #666; margin-bottom: 8px;">原始版本 (OLD)</div>
                                <pre
                                    style="font-family: inherit; white-space: pre-wrap; word-break: break-word; line-height: 1.6; padding: 10px; background: #fff; border-radius: 4px; border: 1px solid #ddd; margin: 0; font-size: 13px; color: #333;">
{{ formatTextForDisplay(currentVersionData?.courseTarget) }}
</pre>
                            </div>
                            <!-- AI优化版本 -->
                            <div
                                style="flex: 1; border: 1px solid #e2e8f0; border-radius: 8px; padding: 15px; background: #f8fafc;">
                                <div style="font-size: 12px; color: #409EFF; margin-bottom: 8px;">AI 优化版本 (可编辑)</div>
                                <template v-if="Array.isArray(aiRefineData.courseTarget)">
                                    <el-input v-for="(item, index) in aiRefineData.courseTarget"
                                        :key="optimizeKey + '-target-' + index"
                                        v-model="aiRefineData.courseTarget[index]" type="textarea" rows="4"
                                        style="width: 100%; margin-bottom: 12px;"></el-input>
                                </template>
                                <el-input v-else :key="optimizeKey + '-target-single'"
                                    v-model="aiRefineData.courseTarget" type="textarea" rows="8"
                                    style="width: 100%;"></el-input>
                            </div>
                        </div>
                    </div>
                    <!-- 3. 特色亮点对比 -->
                    <div class="comparison-section" style="margin-bottom: 20px;">
                        <h4 style="margin-bottom: 10px; color: #1e293b; display: flex; align-items: center; gap: 8px;">
                            <i class="el-icon-star-on" style="color: #409EFF;"></i>
                            3. 特色亮点对比
                        </h4>
                        <div style="display: flex; gap: 20px;">
                            <!-- 原始版本 -->
                            <div
                                style="flex: 1; border: 1px solid #e2e8f0; border-radius: 8px; padding: 15px; background: #f8fafc;">
                                <div style="font-size: 12px; color: #666; margin-bottom: 8px;">原始版本 (OLD)</div>
                                <pre
                                    style="font-family: inherit; white-space: pre-wrap; word-break: break-word; line-height: 1.6; padding: 10px; background: #fff; border-radius: 4px; border: 1px solid #ddd; margin: 0; font-size: 13px; color: #333;">
                {{ formatTextForDisplay(currentVersionData?.courseSpecialty) }}
            </pre>
                            </div>
                            <!-- AI优化版本 -->
                            <div
                                style="flex: 1; border: 1px solid #e2e8f0; border-radius: 8px; padding: 15px; background: #f8fafc;">
                                <div style="font-size: 12px; color: #409EFF; margin-bottom: 8px;">AI 优化版本 (可编辑)</div>
                                <template v-if="Array.isArray(aiRefineData.courseSpecialty)">
                                    <el-input v-for="(item, index) in aiRefineData.courseSpecialty"
                                        :key="optimizeKey + '-specialty-' + index"
                                        v-model="aiRefineData.courseSpecialty[index]" type="textarea" rows="4"
                                        style="width: 100%; margin-bottom: 12px;"></el-input>
                                </template>
                                <el-input v-else :key="optimizeKey + '-specialty-single'"
                                    v-model="aiRefineData.courseSpecialty" type="textarea" rows="8"
                                    style="width: 100%;"></el-input>
                            </div>
                        </div>
                    </div>
                    <!-- 4. 预期成果对比 -->
                    <div class="comparison-section" style="margin-bottom: 20px;">
                        <h4 style="margin-bottom: 10px; color: #1e293b; display: flex; align-items: center; gap: 8px;">
                            <i class="el-icon-success" style="color: #409EFF;"></i>
                            4. 预期成果对比
                        </h4>
                        <div style="display: flex; gap: 20px;">
                            <!-- 原始版本 -->
                            <div
                                style="flex: 1; border: 1px solid #e2e8f0; border-radius: 8px; padding: 15px; background: #f8fafc;">
                                <div style="font-size: 12px; color: #666; margin-bottom: 8px;">原始版本 (OLD)</div>
                                <pre
                                    style="font-family: inherit; white-space: pre-wrap; word-break: break-word; line-height: 1.6; padding: 10px; background: #fff; border-radius: 4px; border: 1px solid #ddd; margin: 0; font-size: 13px; color: #333;">
                {{ formatTextForDisplay(currentVersionData?.courseExpectedOutcome) }}
            </pre>
                            </div>
                            <!-- AI优化版本 -->
                            <div
                                style="flex: 1; border: 1px solid #e2e8f0; border-radius: 8px; padding: 15px; background: #f8fafc;">
                                <div style="font-size: 12px; color: #409EFF; margin-bottom: 8px;">AI 优化版本 (可编辑)</div>
                                <template v-if="Array.isArray(aiRefineData.courseExpectedOutcome)">
                                    <el-input v-for="(item, index) in aiRefineData.courseExpectedOutcome"
                                        :key="optimizeKey + '-outcome-' + index"
                                        v-model="aiRefineData.courseExpectedOutcome[index]" type="textarea" rows="4"
                                        style="width: 100%; margin-bottom: 12px;"></el-input>
                                </template>
                                <el-input v-else :key="optimizeKey + '-outcome-single'"
                                    v-model="aiRefineData.courseExpectedOutcome" type="textarea" rows="8"
                                    style="width: 100%;"></el-input>
                            </div>
                        </div>
                    </div>
                    <!-- 5. 课程大纲对比 -->
                    <div class="comparison-section" style="margin-bottom: 20px;">
                        <h4 style="margin-bottom: 10px; color: #1e293b; display: flex; align-items: center; gap: 8px;">
                            <i class="el-icon-document-copy" style="color: #409EFF;"></i>
                            5. 课程大纲对比
                        </h4>
                        <div style="display: flex; gap: 20px;">
                            <!-- 原始版本 -->
                            <div
                                style="flex: 1; border: 1px solid #e2e8f0; border-radius: 8px; padding: 15px; background: #f8fafc; overflow-y: auto; max-height: 400px;">
                                <div style="font-size: 12px; color: #666; margin-bottom: 8px;">原始版本 (OLD)</div>
                                <div
                                    style="font-family: inherit; white-space: pre-wrap; word-break: break-word; line-height: 1.6; padding: 10px; background: #fff; border-radius: 4px; border: 1px solid #ddd; font-size: 13px; color: #333;">
                                    {{ formatTextForDisplay(currentVersionData?.courseOutline) }}
                                </div>
                            </div>
                            <!-- AI优化版本 -->
                            <div
                                style="flex: 1; border: 1px solid #e2e8f0; border-radius: 8px; padding: 15px; background: #f8fafc; overflow-y: auto; max-height: 500px;">
                                <div style="font-size: 12px; color: #409EFF; margin-bottom: 8px;">AI 优化版本 (可编辑)</div>
                                <div
                                    v-if="Array.isArray(aiRefineData.courseOutline) && aiRefineData.courseOutline.length > 0">
                                    <div v-for="(module, modIndex) in aiRefineData.courseOutline"
                                        :key="optimizeKey + '-mod-' + modIndex" :style="{
                                            marginBottom: '20px',
                                            paddingLeft: '8px',
                                            borderLeft: module.hasModified ? '3px solid #67C23A' : '3px solid #409EFF',
                                            background: module.hasModified ? 'rgba(103, 194, 58, 0.05)' : 'transparent',
                                            padding: '10px',
                                            borderRadius: '4px'
                                        }">
                                        <!-- 一级标题 -->
                                        <div style="position: relative;">
                                            <el-tag v-if="module.hasModified" type="success" size="mini"
                                                style="position: absolute; right: 0; top: -5px; z-index: 10;">修改</el-tag>
                                            <el-input :key="optimizeKey + '-mod-title-' + modIndex"
                                                v-model="module.title" type="textarea" rows="2" :style="{
                                                    width: '100%',
                                                    fontWeight: 'bold',
                                                    marginBottom: '12px'
                                                }"></el-input>
                                        </div>
                                        <!-- 二级标题 -->
                                        <div v-for="(section, secIndex) in module.subSections"
                                            :key="optimizeKey + '-sec-' + modIndex + '-' + secIndex" :style="{
                                                marginLeft: '20px',
                                                marginBottom: '16px',
                                                paddingLeft: '8px',
                                                borderLeft: section.hasModified ? '2px solid #E6A23C' : '2px solid #909399',
                                                background: section.hasModified ? 'rgba(230, 162, 60, 0.05)' : 'transparent',
                                                padding: '8px',
                                                borderRadius: '4px'
                                            }">
                                            <div style="position: relative;">
                                                <el-tag v-if="section.hasModified" type="warning" size="mini"
                                                    style="position: absolute; right: 0; top: -5px; z-index: 10;">修改</el-tag>
                                                <el-input :key="optimizeKey + '-sec-title-' + modIndex + '-' + secIndex"
                                                    v-model="section.title" type="textarea" rows="2" :style="{
                                                        width: '100%',
                                                        fontWeight: '500',
                                                        marginBottom: '8px'
                                                    }"></el-input>
                                            </div>
                                            <!-- 三级标题 -->
                                            <div v-for="(subSection, subSecIndex) in section.subSubSections"
                                                :key="optimizeKey + '-sub-' + modIndex + '-' + secIndex + '-' + subSecIndex"
                                                :style="{
                                                    marginLeft: '20px',
                                                    marginBottom: '8px',
                                                    padding: '6px',
                                                    borderRadius: '4px',
                                                    background: getSubSectionStyle(subSection.title).background,
                                                    borderLeft: getSubSectionStyle(subSection.title).borderLeft
                                                }">
                                                <div style="position: relative;">
                                                    <el-tag v-if="getSubSectionStyle(subSection.title).isNew"
                                                        type="success" size="mini"
                                                        style="position: absolute; right: 0; top: -5px; z-index: 10;">新增</el-tag>
                                                    <el-tag v-else-if="getSubSectionStyle(subSection.title).isModified"
                                                        type="warning" size="mini"
                                                        style="position: absolute; right: 0; top: -5px; z-index: 10;">优化</el-tag>
                                                    <el-input
                                                        :key="optimizeKey + '-sub-title-' + modIndex + '-' + secIndex + '-' + subSecIndex"
                                                        v-model="subSection.title" type="textarea" rows="2" :style="{
                                                            width: '100%',
                                                            fontSize: '13px',
                                                            color: '#555'
                                                        }"></el-input>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <el-input v-else :key="optimizeKey + '-outline-single'"
                                    v-model="aiRefineData.courseOutline" type="textarea" rows="10"
                                    style="width: 100%;"></el-input>
                            </div>
                        </div>
                    </div>
                    <!-- 6. 客户审核信息 -->
                    <!-- <div v-if="aiRefineData.customerReview && Object.keys(aiRefineData.customerReview).length"
                        class="customer-review-section"
                        style="margin-top: 20px; padding: 15px; background: #f0f9eb; border-radius: 8px; border: 1px solid #e1f3d8;">
                        <h4 style="margin-bottom: 10px; color: #1e293b; display: flex; align-items: center; gap: 8px;">
                            <i class="el-icon-check" style="color: #67C23A;"></i>
                            6. 客户企业文化匹配度分析
                        </h4>
                        <div style="font-size: 14px; color: #333; line-height: 1.8;">
                            <p><strong>企业名称：</strong>{{ aiRefineData.customerReview.companyName || '-' }}</p>
                            <p><strong>匹配度：</strong>
                                <el-rate v-model="aiRefineData.customerReview.matchScore" disabled text-color="#ff9900">
                                </el-rate>
                            </p>
                            <p><strong>分析结果：</strong>{{ aiRefineData.customerReview.analysis || '-' }}</p>
                            <p><strong>建议：</strong>{{ aiRefineData.customerReview.suggestions || '-' }}</p>
                        </div>
                    </div> -->
                </div>
            </div>
        </template>
    </aj-form-detail>
</template>

<script>
import ajFormDetail from '@/components/ajForm/ajFormDetail.vue';
import { getAjCourseOutlineRefineAi } from '@/api/api';

export default {
    name: 'AiOptimizeDialog',
    components: {
        ajFormDetail
    },
    props: {
        //弹窗类型：1-暂存区AI优化，2-AI优化对比查看
        AiDiaLogDetailType: {
            type: Number,
            default: 1
        },
        //直接展示对比的原版数据（用于类型2）
        AiShowDetailData: {
            type: Object,
            default: () => ({})
        },
        //直接显示对比对内容（用于类型2）
        AiDiaLogShow: {
            type: Boolean,
            default: false
        },
        //直接展示对比内容的数据
        AiDetailShowData: {
            type: Object,
            default: () => ({})
        },
        // 课程大纲ID
        acoId: {
            type: [String, Number],
            default: null
        },
        // 课程详情数据
        courseData: {
            type: Object,
            default: () => ({})
        },
        // 当前版本索引
        versionIndex: {
            type: Number,
            default: 0
        },
        // 弹窗标题
        dialogTitle: {
            type: String,
            default: '大纲优化'
        },
        // 自定义底部按钮（由父组件传入）
        footerButtons: {
            type: Array,
            default: null
        },
        // 弹窗宽度
        dialogWidth: {
            type: [String, Number],
            default: '1200px'
        }
    },
    data() {
        return {
            detailData: {},
            visible: false,
            isOptimized: false,
            optimizeKey: 'ai',
            detailSections: [],
            aiOptimizeForm: {
                requirementDesc: '',
                targetAudience: '',
                targetCustomer: '',
                courseDays: '',
            },
            aiRefineData: {
                courseIntroduce: '',
                courseTarget: '',
                courseSpecialty: '',
                courseExpectedOutcome: '',
                courseOutline: '',
                customerReview: {}
            },
            customSections: [
                {
                    slotName: 'aiCourseOutlineList',
                    title: 'AI 深度优化需求分析',
                    order: 1
                }
            ]
        };
    },
    computed: {

        // 最终使用的底部按钮（优先使用父组件传入的）
        finalFooterButtons() {
            // 如果父组件传入了 footerButtons，则使用父组件的
            if (this.footerButtons && this.footerButtons.length > 0) {
                return this.footerButtons;
            }
            // 否则使用默认按钮
            const buttons = [
                { text: '关闭', plain: true },
                { text: '导出word', type: 'primary', onClick: this.handleSaveOptimized }
            ];
            return buttons;
        },
        // 当前版本数据
        currentVersionData() {
            if (
                !this.detailData.ajCourseOutlineList ||
                !Array.isArray(this.detailData.ajCourseOutlineList) ||
                this.detailData.ajCourseOutlineList.length === 0
            ) {
                return null;
            }
            const index = this.versionIndex || 0;
            return this.detailData.ajCourseOutlineList[index] || this.detailData.ajCourseOutlineList[0];
        }
    },
    watch: {
        // 监听 courseData 变化，同步到 detailData
        courseData: {
            handler(newVal) {
                if (newVal && Object.keys(newVal).length > 0) {
                    this.detailData = JSON.parse(JSON.stringify(newVal));
                }
            },
            immediate: true
        },
        // 监听版本索引变化
        versionIndex() {
            // 版本索引变化时重新计算 currentVersionData
        }
    },
    methods: {
        // 打开弹窗
        open() {
            this.visible = true;
            this.resetData();
            // 同步课程数据
            if (this.courseData && Object.keys(this.courseData).length > 0) {
                this.detailData = JSON.parse(JSON.stringify(this.courseData));
            }
        },
        // 关闭弹窗
        close() {
            this.visible = false;
        },
        // 重置数据
        resetData() {
            this.isOptimized = false;
            this.optimizeKey = 'ai';
            this.aiOptimizeForm = {
                requirementDesc: '',
                targetAudience: '',
                targetCustomer: '',
                courseDays: ''
            };
            this.aiRefineData = {
                courseIntroduce: '',
                courseTarget: '',
                courseSpecialty: '',
                courseExpectedOutcome: '',
                courseOutline: '',
                customerReview: {}
            };
        },
        // 辅助函数：格式化文本用于展示
        formatTextForDisplay(text) {
            if (!text) return '';
            return text;
        },
        // 获取子标题的样式
        getSubSectionStyle(title) {
            if (!title) return { background: 'transparent', borderLeft: 'none', isNew: false, isModified: false };
            const titleStr = String(title);
            const isNew = titleStr.includes('（新增）') || titleStr.includes('(新增)');
            const isModified = titleStr.includes('（优化') || titleStr.includes('(优化') ||
                titleStr.includes('（扩展') || titleStr.includes('(扩展') ||
                titleStr.includes('（新增：') || titleStr.includes('(新增：');
            if (isNew) {
                return {
                    background: 'rgba(103, 194, 58, 0.08)',
                    borderLeft: '3px solid #67C23A',
                    isNew: true,
                    isModified: false
                };
            } else if (isModified) {
                return {
                    background: 'rgba(230, 162, 60, 0.08)',
                    borderLeft: '3px solid #E6A23C',
                    isNew: false,
                    isModified: true
                };
            }
            return {
                background: 'transparent',
                borderLeft: 'none',
                isNew: false,
                isModified: false
            };
        },
        // AI优化点击
        async handleAiOptimizeClick() {
            this.isOptimizing = true;
            this.$loading.show();
            this.isOptimized = false;
            this.aiOptimizeForm.acoId = this.currentVersionData.acoId
            const newData = JSON.parse(JSON.stringify(this.aiOptimizeForm));
            try {
                const res = await getAjCourseOutlineRefineAi(newData);
                if (res.status == 200) {
                    this.isOptimized = true;
                    this.optimizeKey = Date.now().toString();
                    // 映射AI返回的数据
                    const aiData = res.data;
                    this.$set(this.aiRefineData, 'courseIntroduce', aiData.introduction || this.currentVersionData?.courseIntroduce || '');
                    const courseTarget = (Array.isArray(aiData.objectives) && aiData.objectives.length > 0)
                        ? [...aiData.objectives]
                        : (this.currentVersionData?.courseTarget || '');
                    this.$set(this.aiRefineData, 'courseTarget', courseTarget);
                    const courseSpecialty = (Array.isArray(aiData.highlights) && aiData.highlights.length > 0)
                        ? [...aiData.highlights]
                        : (this.currentVersionData?.courseSpecialty || '');
                    this.$set(this.aiRefineData, 'courseSpecialty', courseSpecialty);
                    const courseExpectedOutcome = (Array.isArray(aiData.expected0utcome) && aiData.expected0utcome.length > 0)
                        ? [...aiData.expected0utcome]
                        : (this.currentVersionData?.courseExpectedOutcome || '');
                    this.$set(this.aiRefineData, 'courseExpectedOutcome', courseExpectedOutcome);
                    const courseOutline = (Array.isArray(aiData.outline) && aiData.outline.length > 0)
                        ? JSON.parse(JSON.stringify(aiData.outline))
                        : (this.currentVersionData?.courseOutline || '');
                    this.$set(this.aiRefineData, 'courseOutline', courseOutline);
                    this.$set(this.aiRefineData, 'customerReview', JSON.parse(JSON.stringify(aiData.customerReview || {})));
                    this.$message.success('AI优化完成！');
                    console.log('AI优化结果:', this.aiRefineData);

                } else {
                    this.$message.error('AI优化失败');
                }
            } catch (error) {
                console.error('AI优化请求失败:', error);
                this.$message.error(`AI优化失败：${error.message}`);
            } finally {
                this.$loading.close();
            }
        },
        // 保存优化后的数据
        handleSaveOptimized() {
            if (!this.isOptimized && !this.AiDiaLogShow) {
                this.$message.warning('请先进行AI优化！');
                return;
            }
            // 优先从detailData顶层获取基础字段，如果没有则从currentVersionData获取
            const baseData = this.detailData || {};
            const versionData = this.currentVersionData || {};
            // courseStyle 字段存储的是课程时长，需要赋值给 courseDays 供导出模板使用
            const courseStyleValue = baseData.courseStyle || versionData.courseStyle || '';
            const saveData = {
                acoId: this.acoId,
                acsuName: baseData.acsuName || versionData.acsuName || '',
                courseTitle: baseData.courseTitle || versionData.courseTitle || '',
                courseStyleDes: baseData.courseStyleDes || versionData.courseStyleDes || '',
                courseStyle: courseStyleValue,
                courseDays: courseStyleValue, // courseDays 映射到 courseDuration 用于导出
                courseOutline: this.formatOutlineToText(this.aiRefineData.courseOutline),
                courseIntroduce: this.aiRefineData.courseIntroduce || '',
                courseTarget: Array.isArray(this.aiRefineData.courseTarget)
                    ? this.aiRefineData.courseTarget.join('\n')
                    : (this.aiRefineData.courseTarget || ''),
                courseSpecialty: Array.isArray(this.aiRefineData.courseSpecialty)
                    ? this.aiRefineData.courseSpecialty.join('\n')
                    : (this.aiRefineData.courseSpecialty || ''),
                courseExpectedOutcome: Array.isArray(this.aiRefineData.courseExpectedOutcome)
                    ? this.aiRefineData.courseExpectedOutcome.join('\n')
                    : (this.aiRefineData.courseExpectedOutcome || ''),
                customerReview: JSON.stringify(this.aiRefineData.customerReview || {})
            };
            // 返回aiRefineData和saveData两个参数
            this.$emit('save',saveData,this.aiRefineData);
        },
        // 将结构化的课程大纲数组转换为纯文本格式
        formatOutlineToText(outlineArray) {
            if (!Array.isArray(outlineArray)) return '';
            let text = '';
            for (let module of outlineArray) {
                text += `${module.title + '\n'}`;
                if (module.subSections && module.subSections.length > 0) {
                    for (let section of module.subSections) {
                        text += `${section.title + '\n'}`;
                        if (section.subSubSections && section.subSubSections.length > 0) {
                            for (let subSection of section.subSubSections) {
                                text += `${subSection.title + '\n'}`;
                            }
                        }
                    }
                }
                text += '';
            }
            return text.trim();
        }
    }
};
</script>

<style scoped>
/* 弹窗内加载动画 */
.mario-loading-dialog {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10000;
    backdrop-filter: blur(4px);
    animation: fadeIn 0.3s ease-in-out;
}

.mario-loading-content {
    background: linear-gradient(135deg, #5c94fc 0%, #5c94fc 70%, #c84c0c 70%, #c84c0c 85%, #000 85%);
    padding: 20px;
    border-radius: 16px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);
    animation: scaleIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

@keyframes scaleIn {
    from {
        opacity: 0;
        transform: scale(0.9);
    }

    to {
        opacity: 1;
        transform: scale(1);
    }
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

/* AI优化结果部分样式 */
.ai-result-section h4 {
    border-bottom: 2px solid #e2e8f0;
    padding-bottom: 8px;
    margin-bottom: 15px;
}

.comparison-section .el-input__inner {
    font-family: inherit;
    font-size: 13px;
    line-height: 1.5;
}

.customer-review-section ul {
    padding-left: 20px;
    margin: 0;
}

.customer-review-section li {
    margin-bottom: 5px;
}
</style>
